module.exports = __webpack_public_path__ + "static/dashboard-ca61688bda9fa7b0c5910bde9acc526b.png";